/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {CardSystemWidget2} from '../../../_metronic/partials/widgets'
import {useIntl} from 'react-intl'
import {AnimaDireita} from '../../../_metronic/assets/animation/styles'

const DashboardPage: FC = () => {
  const intl = useIntl()
  return (
    <>
      <AnimaDireita>
        <div className='row g-4 g-xl-4 mx-auto'>
          <div className='col-lg-4 col-sm-6'>
            <Link className='text-dark' to='/sga'>
              <CardSystemWidget2
                className='card-xl-stretch '
                image='/media/subsystem/logo_sga.svg'
                image2='/media/subsystem/logo_sga1.png'
                title='SGA'
                description={intl.formatMessage({id: 'CARD.SGA'})}
              />
            </Link>
          </div>

          {/* <div className='col-lg-4 col-sm-6'>
            <Link className='text-dark' to='/sgt'>
              <CardSystemWidget2
                className='card-xl-stretch mb-xl-8'
                image='/media/subsystem/logo_sgt.svg'
                image2='/media/subsystem/logo_sgt1.png'
                title='SGT'
                description={intl.formatMessage({id: 'CARD.SGT'})}
              />
            </Link>
          </div> */}

          {/* <div className='col-lg-4 col-sm-6'>
            <Link className='text-dark' to='/sgc'>
              <CardSystemWidget2
                className='card-xl-stretch mb-xl-8'
                image='/media/subsystem/logo_sgc.svg'
                image2='/media/subsystem/logo_sgc1.png'
                title='SGC'
                description={intl.formatMessage({id: 'CARD.SGC'})}
              />
            </Link>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <Link className='text-dark' to='/sgo'>
              <CardSystemWidget2
                className='card-xl-stretch mb-xl-8'
                image='/media/subsystem/logo_sgo.svg'
                image2='/media/subsystem/logo_sgo1.png'
                title='SGO'
                description={intl.formatMessage({id: 'CARD.SGO'})}
              />
            </Link>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <Link className='text-dark' to='/ifc'>
              <CardSystemWidget2
                className='card-xl-stretch'
                image='/media/subsystem/logo_ifc.svg'
                image2='/media/subsystem/logo_ifc1.png'
                title='IFC'
                description={intl.formatMessage({id: 'CARD.IFC'})}
              />
            </Link>
          </div> */}
        </div>
      </AnimaDireita>
    </>
  )
}

const DashboardWrapper: FC = () => {
  // const intl = useIntl()
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <PageTitle breadcrumbs={[]}>{}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
